import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=496226b6&"
import script from "./AdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./AdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports